<script setup lang="ts">
import { DropdownMenuSubContent } from 'reka-ui';

withDefaults(
    defineProps<{
        sideOffset?: number;
    }>(),
    {
        sideOffset: 2,
    },
);
</script>

<template>
    <DropdownMenuSubContent
        :side-offset="sideOffset"
        class="z-[100] min-w-[12rem] overflow-y-auto rounded-lg border bg-white py-1 shadow-muval-3 outline-none data-[state=closed]:animate-dropdownOut data-[state=open]:animate-dropdownIn"
    >
        <slot />
    </DropdownMenuSubContent>
</template>
